import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../helpers/reducerRegistry'
import {
  PAGE_SIZE_VIEW_ALL,
  SCREEN_TYPE,
  mapFilterActiveKey,
} from '../constants'
import { handleIds, handleNotificationsData, keyById } from './helper'
import { getPaged, getUserNotificationSettings } from './thunk'

const { VIEW_ALL, POPUP } = SCREEN_TYPE
export const NOTIFICATIONS_DEFAULT = {
  todayData: {},
  olderData: {},
}
export const NOTIFICATIONS_DEFAULT_IDS = {
  todayIds: [],
  olderIds: [],
}

const initialState = {
  notifications: {
    [VIEW_ALL]: NOTIFICATIONS_DEFAULT,
    [POPUP]: NOTIFICATIONS_DEFAULT,
  },
  page: {
    [VIEW_ALL]: 1,
    [POPUP]: 1,
  },
  loading: {
    notifications: {
      [VIEW_ALL]: true,
      [POPUP]: true,
    },
    userNotificationsSettings: true,
  },
  rawData: {
    [VIEW_ALL]: {},
    [POPUP]: {},
  },
  ids: {
    [VIEW_ALL]: NOTIFICATIONS_DEFAULT_IDS,
    [POPUP]: NOTIFICATIONS_DEFAULT_IDS,
  },
  isScroll: false,
  tab: mapFilterActiveKey.ALL,
  pageSize: PAGE_SIZE_VIEW_ALL,
  userNotificationsSettings: {},
}

const slice = createSlice({
  name: 'systemNotifications',
  initialState,
  reducers: {
    changePage: (state, action) => {
      const { screenType, newPage } = action.payload
      state.page[screenType] = newPage
    },
    changeTab: (state, action) => {
      state.tab = action.payload
    },
    changeIsScroll: (state, action) => {
      state.isScroll = action.payload
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload
    },
    changeSetting: (state, action) => {
      const { rowId, keySetting, newSetting } = action.payload
      state.userNotificationsSettings[rowId][keySetting] = newSetting
    },
    changeIsRead: (state, action) => {
      const { screenType, timeType, id, isRead } = action.payload
      state.notifications[screenType][timeType][id].isRead = isRead
    },
    maskAllAsRead: (state, action) => {
      const { screenType } = action.payload
      state.ids[screenType].todayIds.forEach((id) => {
        state.notifications[screenType].todayData[id].isRead = true
      })
      state.ids[screenType].olderIds.forEach((id) => {
        state.notifications[screenType].olderData[id].isRead = true
      })
    },
    deleteNotification: (state, action) => {
      const { screenType, timeType, id } = action.payload
      state.notifications[screenType][timeType][id].isShow = false
    },
    resetPopupData: (state) => {
      state.notifications[POPUP] = NOTIFICATIONS_DEFAULT
      state.page[POPUP] = 1
      state.rawData[POPUP] = {}
      state.ids[POPUP] = NOTIFICATIONS_DEFAULT_IDS
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPaged.pending, (state, action) => {
      const { screenType } = action.meta.arg
      state.loading.notifications[screenType] = true
    })
    builder.addCase(getPaged.fulfilled, (state, action) => {
      const { screenType } = action.meta.arg
      state.notifications[screenType] = handleNotificationsData(
        action.payload,
        action.meta.arg,
        state.notifications[screenType],
      )
      state.rawData[screenType] = action.payload
      state.ids[screenType] = handleIds(state.notifications[screenType])
      state.loading.notifications[screenType] = false
    })
    builder.addCase(getPaged.rejected, (state, action) => {
      const { screenType } = action.meta.arg
      state.loading.notifications[screenType] = action.payload.loading
    })
    builder.addCase(getUserNotificationSettings.pending, (state) => {
      state.loading.userNotificationsSettings = true
    })
    builder.addCase(getUserNotificationSettings.fulfilled, (state, action) => {
      const data = action.payload || []
      state.userNotificationsSettings = keyById(data, 'notificationTypeId')
      state.loading.userNotificationsSettings = false
    })
    builder.addCase(getUserNotificationSettings.rejected, (state, action) => {
      state.loading.userNotificationsSettings = action.payload.loading
    })
  },
})

export const {
  changePage,
  changeTab,
  resetPopupData,
  changeIsScroll,
  changePageSize,
  changeSetting,
  changeIsRead,
  deleteNotification,
  maskAllAsRead,
} = slice.actions

export const selectPage = (screenType) => (state) =>
  state[slice.name].page[screenType]
export const selectTab = (state) => state[slice.name].tab
export const selectLoadingByKey = (key, screenType) => (state) => {
  if (screenType) return state[slice.name].loading[key][screenType]
  return state[slice.name].loading[key]
}
export const selectRawData = (screenType) => (state) =>
  state[slice.name].rawData[screenType]
export const selectIsScroll = (state) => state[slice.name].isScroll
export const selectPageSize = (state) => state[slice.name].pageSize
export const selectUserSettings = (state) =>
  state[slice.name].userNotificationsSettings
export const selectCellDataById = (rowId, colId) => (state) =>
  colId
    ? state[slice.name].userNotificationsSettings[rowId][colId]
    : state[slice.name].userNotificationsSettings[rowId]

export const selectIds = (screenType) => (state) =>
  state[slice.name].ids[screenType]
export const selectNotification = (screenType, timeType, id) => (state) =>
  state[slice.name].notifications[screenType][timeType][id]

register(slice.name, slice.reducer)
